import React from 'react'
import { useNavigate, useSearchParams } from 'router'
import { gql, useQuery } from '@apollo/client'
import { Box, CircularProgress } from '@mui/material'
import { useUser, useSites } from 'store'
import { BYPASSES_DISCLAIMER_KEY } from 'variables'

import useActions from './use-actions'

export const OPERATION_ME = gql`
  query me {
    me {
      user_id
      user_type
      first_name
      last_name
      email
      admin
      has_stime_sites
      sf_contact_id
      fake
      roles
      internal
      last_sign_in_at
      deleted_at
      experience_cloud
      phone
      mobile_phone
      title
      salutation
      country
      created_at
      updated_at
      two_fa_activated
      beta_only_at
      bypasses_disclaimer
      demo_mode
      accounts {
        id
        name
        hierarchie
        nb_children
        sf_parent_id
        in_perimeter
        sf_id
        is_site
        state
      }
    }
  }
`

const Me = () => {
  const [, setUser] = useUser()
  const [, setSites] = useSites()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { logout } = useActions()

  const checkDefaultSite = (user) => {
    const sites = user.accounts.filter(({ is_site }) => is_site)
    if (sites.length === 1) {
      const selection = sites[0].hierarchie.map(hierarchy => user.accounts.find(({ sf_id }) => sf_id === hierarchy))
      setSites(prev => ({ ...prev, selected: sites, accounts: selection }))
    }
  }

  const addUser = (me) => {
    const bypassesDisclaimer = localStorage.getItem(BYPASSES_DISCLAIMER_KEY) === null
      ? me.bypasses_disclaimer
      : localStorage.getItem(BYPASSES_DISCLAIMER_KEY) === 'true'
    setUser({ ...me, bypasses_disclaimer: bypassesDisclaimer })
  }

  const shouldShowBetaDisclaimer = (user) => {
    const hasBetaOnlyParam = searchParams.has('beta_only_at')
    return !!user.beta_only_at && hasBetaOnlyParam
  }

  const { error, loading } = useQuery(OPERATION_ME, {
    fetchPolicy: 'no-cache',
    onCompleted: async ({ me }) => {
      addUser(me)
      checkDefaultSite(me)
      try {
        const { selected, accounts } = localStorage.getItem('sites')
          ? JSON.parse(localStorage.getItem('sites') || '')
          : { selected: [], accounts: [] }
        setSites(prev => ({ ...prev, selected, accounts }))
      } catch (e) {
        console.error(e)
      }

      if (shouldShowBetaDisclaimer(me)) {
        navigate({ pathname: '/auth/disclaimer-beta-only' })
        return
      }

      navigate({ pathname: searchParams.get('redirect') || '/' })
    },
    onError: async (error) => {
      console.log(error)
      await logout()
    }
  })

  if (error) {
    return null
  } else if (loading) {
    return (
      <Box
        position="absolute"
        top="calc(50% - 50px)"
        left="calc(50% - 50px)"
      >
        <CircularProgress size={60} />
      </Box>
    )
  }

  return null
}

export default Me
